export const showPhoneWithoutCountryCode = ({
  phone,
  frictionlessCheckoutCountry,
}: {
  phone: string;
  frictionlessCheckoutCountry: Record<string, any>;
}) => {
  if (phone.includes(frictionlessCheckoutCountry?.dial_code)) {
    return phone.replace(frictionlessCheckoutCountry?.dial_code, '').trim();
  } else {
    return phone;
  }
};
